<template>
    <b-modal
      size="md"
      :hideFooter="true"
      :hideHeader="true"
      id="confirmDeleteModal"
    >
      <template slot="default">
        <b-row>
          <b-col class="float-left">
            <em class="fas fa-lg fa-exclamation"></em>
          </b-col>
        </b-row>
        <b-container class="confirm-modal-cnt">
          <b-row class="text-center">
            <h6 class="confirm-modal-text">
              Вы действительно хотите удалить данного пользователя?
            </h6>
          </b-row>
          <b-row class="text-center ">
            <h5 class="deleteName">
              {{ this.deleteSurname }} {{ this.deleteName }} {{ this.deleteMidname }}
            </h5>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-6">
              <b-button @click="deleteUser" class="confirm-modal-btn" variant="primary">
                Удалить
              </b-button>
            </b-col>
            <b-col class="col-12 col-md-6">
              <b-button @click="closeModal" class="confirm-modal-btn" variant="outline-primary">
                Отмена
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>
</template>

<script>

import usersApi from '@/api/users'

export default {
  name: 'ConfirmDeleteModal',
  props: {
    name: {
      type: String,
      default() {
        return ''
      }
    },
    surname: {
      type: String,
      default() {
        return ''
      }
    },
    midname: {
      type: String,
      default() {
        return ''
      }
    },
    id: {
      type: Number,
      default() {
        return null
      }
    }
  },
  computed: {
    deleteName: {
      get() {
        return this.name
      },
      set() {
        this.name = this.$props.name
      }
    },
    deleteSurname: {
      get() {
        return this.surname
      },
      set() {
        this.surname = this.$props.surname
      }
    },
    deleteMidname: {
      get() {
        return this.midname
      },
      set() {
        this.midname = this.$props.midname
      }
    },
    deleteId: {
      get() {
        return this.id
      },
      set() {
        this.id = this.$props.id
      }
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide('confirmDeleteModal')
    },
    deleteUser() {
      usersApi.deleteUser(this.deleteId)
        .then(() => {
          this.$emit('userDeleted')
          this.closeModal()
        })
        .catch(() => {
        })
    }
  }
}
</script>

<style scoped lang="scss">

  .confirm-modal-btn {
    width: 100% !important;
  }

  .confirm-modal-text {
    display: inline-block;
    margin: 0 auto;
    width: 90%;
    margin-bottom: 20px;
  }

  .deleteName {
    width: 100%;
    margin-bottom: 20px;
  }

</style>
